// Branding (Pipeline since cf-c86, ex-CineForge): rewrites upstream (Moodwalkrs / Corpus) names in user-visible text.
// Applied to every i18n string at startup, so new upstream strings are covered without
// editing upstream locale files. Keep in sync with backend/cineforge/branding.py.

export const BRAND_RULES = [
  [/Powered by Corpus Corp\.?/g, "Powered by INEVITABLE"],
  [/Corpus Corp\.?/gi, "INEVITABLE"],
  [/Corpus AI(?: \d+(?:\.\d+)?)?(?: Pro)?/g, "Pipeline AI"],
  [/\bCorpus\b/g, "Pipeline AI"],
  [/Moodwalkrs Studio/g, "Pipeline"],
  [/MOODWALKRS STUDIO/g, "PIPELINE"],
  [/MOODWALKRS/g, "PIPELINE"],
  [/@moodwalkrs\.com/gi, "@inevitable.click"],
  [/Moodwalkrs/g, "Pipeline"],
];

export function rebrand(text) {
  if (typeof text !== "string" || !/moodwalkrs|corpus/i.test(text)) return text;
  return BRAND_RULES.reduce((s, [re, to]) => s.replace(re, to), text);
}

export function rebrandTree(node) {
  if (typeof node === "string") return rebrand(node);
  if (Array.isArray(node)) return node.map(rebrandTree);
  if (node && typeof node === "object") {
    const out = {};
    Object.keys(node).forEach((k) => { out[k] = rebrandTree(node[k]); });
    return out;
  }
  return node;
}

// Rebrand every loaded translation namespace in place (deep, overwrite).
export function rebrandI18n(i18n) {
  const data = i18n?.store?.data || {};
  Object.keys(data).forEach((lng) => {
    Object.keys(data[lng] || {}).forEach((ns) => {
      i18n.addResourceBundle(lng, ns, rebrandTree(data[lng][ns]), true, true);
    });
  });
}
